import { render, staticRenderFns } from "./AIncludeSelfAssessmentCheckbox.reg.vue?vue&type=template&id=600e2cad&scoped=true&"
import script from "./AIncludeSelfAssessmentCheckbox.reg.vue?vue&type=script&lang=ts&"
export * from "./AIncludeSelfAssessmentCheckbox.reg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600e2cad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
